// extracted by mini-css-extract-plugin
export default {"changePasswordContainer":"change_pw_changePasswordContainer__5A2ql"};